import { defineMessages } from 'react-intl';

export default defineMessages({
  cardNameInputId: {
    id: 'SteppedCheckout.CreditCard.ids.cardName',
    description: 'Credit Card Card Name Id',
    defaultMessage: 'card-name',
  },
  cardNumberInputId: {
    id: 'SteppedCheckout.CreditCard.ids.cardNumber',
    description: 'Credit Card Card Number Id',
    defaultMessage: 'card-number',
  },
  cardExpiryDateInputId: {
    id: 'SteppedCheckout.CreditCard.ids.cardDate',
    description: 'Credit Card Card Date Id',
    defaultMessage: 'card-date',
  },
  cardSecurityCodeInputId: {
    id: 'SteppedCheckout.CreditCard.ids.cardCVV',
    description: 'Credit Card Security Code Id',
    defaultMessage: 'card-cvv',
  },
  cardPostalCodeInputId: {
    id: 'SteppedCheckout.CreditCard.ids.cardPostalCode',
    description: 'Credit Card Postal Code Id',
    defaultMessage: 'card-postal-code',
  },
  cardNumberLabel: {
    id: 'SteppedCheckout.CreditCard.labels.cardNumber',
    description: 'Credit Card Card Number Label',
    defaultMessage: 'Card Number*',
  },
  cardNameLabel: {
    id: 'SteppedCheckout.CreditCard.labels.nameOnCard',
    description: 'Credit Card Name Label',
    defaultMessage: 'Name on Card*',
  },
  cardExpiryDateLabel: {
    id: 'SteppedCheckout.CreditCard.labels.ExpirationDate',
    description: 'Credit Card Expiration Date Label',
    defaultMessage: 'Expiration Date*',
  },
  cardSecurityCodeLabel: {
    id: 'SteppedCheckout.CreditCard.labels.SecurityCode',
    description: 'Credit Card Security Code Label',
    defaultMessage: 'Security Code*',
  },
  cardPostalCodeLabel: {
    id: 'SteppedCheckout.CreditCard.labels.PostalCode',
    description: 'Credit Card Postal Code Label',
    defaultMessage: 'ZIP Code*',
  },
  cardLogoAltMessage: {
    id: 'SteppedCheckout.CreditCard.cardLogoAltMessage',
    description: 'Card logo alt message',
    defaultMessage: 'Credit Card Logo',
  },
  cvvTooltipMessage: {
    id: 'SteppedCheckout.CreditCard.cvvTooltipMessage',
    defaultMessage:
      '<div>The CVV (credit card identification number)<br/>is an added safeguard for your credit card<br/>purchases. Depending on the type of credit<br/>card you use, it is the 3- or 4-digit number<br/>printed on the back or front of your credit card.</div>',
  },
  invalidCardHolderName: {
    id: 'SteppedCheckout.CreditCard.invalidCardHolderName',
    defaultMessage: 'Enter name on card. Field cannot be blank.',
  },
  invalidCard: {
    id: 'SteppedCheckout.CreditCard.invalidCard',
    defaultMessage: 'Enter a valid card number.',
  },
  invalidExp: {
    id: 'SteppedCheckout.CreditCard.invalidExp',
    defaultMessage: 'Select expiration date',
  },
  invalidSecurityCode: {
    id: 'SteppedCheckout.CreditCard.invalidSecurityCode',
    defaultMessage: 'Enter a valid security code.',
  },
  emptySecurityCode: {
    id: 'SteppedCheckout.CreditCard.emptySecurityCode',
    defaultMessage: 'Enter security code. Field cannot be blank.',
  },
  invalidPostalCode: {
    id: 'SteppedCheckout.CreditCard.invalidPostalCode',
    defaultMessage: 'Enter a valid zipcode.',
  },
  emptyPostalCode: {
    id: 'SteppedCheckout.CreditCard.emptyPostalCode',
    defaultMessage: 'Enter zipcode. Field cannot be blank.',
  },
  cardStreetAddressInputId: {
    id: 'SteppedCheckout.CreditCard.ids.cardStreetAddress',
    description: 'Credit Card Street Address Id',
    defaultMessage: 'card-street-address',
  },
  cardStreetAddressLabel: {
    id: 'SteppedCheckout.CreditCard.labels.StreetAddress',
    description: 'Credit Card Street Address Label',
    defaultMessage: 'Street Address*',
  },
});